module.exports = require("@material-ui/core/esm/DialogContent");